import { render, staticRenderFns } from "./OrderHistoryTab.vue?vue&type=template&id=55f06d24&scoped=true&"
import script from "./OrderHistoryTab.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTab.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryTab.vue?vue&type=style&index=0&id=55f06d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f06d24",
  null
  
)

export default component.exports